export default __webpack_public_path__ + "static/media/splitConduitsCover.51e78934.jpg";